var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTabMineSelect = function SvgIconTabMineSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.0384 12 14.0534 11.6921 14.9167 11.1152C15.7801 10.5383 16.453 9.71837 16.8504 8.75906C17.2477 7.79975 17.3517 6.74415 17.1491 5.72575C16.9466 4.70735 16.4465 3.77189 15.7123 3.03766C14.9781 2.30344 14.0426 1.80342 13.0242 1.60085C12.0058 1.39828 10.9502 1.50224 9.99091 1.8996C9.0316 2.29696 8.21166 2.96987 7.63478 3.83323C7.05791 4.69659 6.75 5.71162 6.75 6.74997C6.75 8.14236 7.30312 9.47772 8.28769 10.4623C9.27226 11.4468 10.6076 12 12 12ZM12 13.5C8.74594 13.5 2.25 15.51 2.25 19.5V22.5H21.75V19.5C21.75 15.51 15.2541 13.5 12 13.5Z",
    fill: "#43C6A7"
  })));
};
export default SvgIconTabMineSelect;